// 经纬度逆地址解析
export const getCompleteAddress = (point) => {
  return new Promise((resolve, reject) => {
    const geocoder = new BMap.Geocoder();
    geocoder.getLocation(point, (result) => {
      if (!result) {
        return reject("定位失败");
      }
      console.log("经纬度逆地址解析成功", result);

      const addressComponents = result.addressComponents;
      const detailedAddress = addressComponents.streetNumber
        ? result.address
        : getClosestAddress(result.content?.surround_poi);

      resolve(detailedAddress); // 使用 resolve 返回获取到的地址
    });
  });
};

const getClosestAddress = (surroundPoi) => {
  if (!surroundPoi || surroundPoi.length === 0) {
    return '无近似位置信息';
  }
  
  const closestLocation = surroundPoi.reduce((closest, current) => {
    return parseInt(current.distance) < parseInt(closest.distance) ? current : closest;
  }, surroundPoi[0]);

  return closestLocation?.addr || '定位失败';
};